/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type OrganizationSignupMutationVariables = Types.Exact<{
  input: Types.OrganizationSignupInput;
}>;


export type OrganizationSignupMutation = { __typename: 'Mutation', organizationSignup: { __typename: 'Organization', id: string, name: string, createdAt: any, displayCount: number, handle: string, countryCode?: string | null, enableMfa?: boolean | null, owner?: { __typename: 'OwnerUser', id: string, email: string, organizationId: string, lastLogin?: any | null } | null, proStore?: { __typename: 'ProStoreConnection', id: string, createdAt: any, developerAccess: boolean } | null } };


export const OrganizationSignupDocument = gql`
    mutation OrganizationSignup($input: OrganizationSignupInput!) {
  organizationSignup(input: $input) {
    id
    name
    createdAt
    displayCount
    handle
    countryCode
    enableMfa
    owner {
      id
      email
      organizationId
      lastLogin
    }
    proStore {
      id
      createdAt
      developerAccess
    }
  }
}
    `;
export type OrganizationSignupMutationFn = ApolloReactCommon.MutationFunction<OrganizationSignupMutation, OrganizationSignupMutationVariables>;

/**
 * __useOrganizationSignupMutation__
 *
 * To run a mutation, you first call `useOrganizationSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationSignupMutation, { data, loading, error }] = useOrganizationSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationSignupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganizationSignupMutation, OrganizationSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganizationSignupMutation, OrganizationSignupMutationVariables>(OrganizationSignupDocument, options);
      }
export type OrganizationSignupMutationHookResult = ReturnType<typeof useOrganizationSignupMutation>;
export type OrganizationSignupMutationResult = ApolloReactCommon.MutationResult<OrganizationSignupMutation>;
export type OrganizationSignupMutationOptions = ApolloReactCommon.BaseMutationOptions<OrganizationSignupMutation, OrganizationSignupMutationVariables>;